import type { MerchantDraftItem } from "@unbox/api";

type DraftProgressInput = Pick<MerchantDraftItem, "data" | "credentialGroup" | "shopConnectedAt">;

export const merchantDraftProgress = ({ data, credentialGroup, shopConnectedAt }: DraftProgressInput): number => {
  const checks = [
    !!data.details?.handle.trim(),
    !!data.details?.name.trim(),
    !!credentialGroup,
    !!shopConnectedAt,
    !!data.detection,
    !!data.handling,
  ];
  return Math.round((checks.filter(Boolean).length / checks.length) * 100);
};
